import { BlankLayout, RouteView } from '@/layouts'
// import { RouteView, SimpleLayout } from '@/layouts'

export const asyncRouterMap = [
  {
    path: '/aaa',
    name: 'Aaa',
    component: BlankLayout,
    meta: { title: '首页', permission: ['teacher'] }
  },
  {
    path: '/teacher',
    component: RouteView,
    redirect: '/teacher/info',
    meta: { permission: ['teacher'] },
    children: [
      {
        path: 'info',
        name: 'TeacherInfo',
        component: () => import('../views/teacher/Info.vue'),
        meta: {
          title: '教员基本信息',
          permission: ['teacher']
        }
      },
      {
        path: 'security',
        name: 'TeacherSecurity',
        component: () => import('../views/teacher/Security.vue'),
        meta: {
          title: '教员安全中心',
          permission: ['teacher']
        }
      },
      {
        path: 'realname',
        name: 'TeacherRealname',
        component: () => import('../views/teacher/Realname.vue'),
        meta: {
          title: '实名认证',
          permission: ['teacher']
        }
      },
      {
        path: 'realname',
        name: 'TeacherRealname',
        component: () => import('../views/teacher/Realname.vue'),
        meta: {
          title: '实名认证',
          permission: ['teacher']
        }
      },
      {
        path: 'apply',
        name: 'TeacherApply',
        component: () => import('../views/teacher/Apply.vue'),
        meta: {
          title: '成为教员',
          permission: ['teacher']
        }
      },
      {
        path: 'service-pack',
        name: 'TeacherServicePack',
        component: () => import('../views/teacher/ServicePack.vue'),
        meta: {
          title: '服务包管理',
          permission: ['teacher']
        }
      },
      {
        path: 'pack-info',
        name: 'TeacherPackInfo',
        component: () => import('../views/teacher/PackInfo.vue'),
        props: (route) => ({ id: route.query.id }),
        meta: {
          title: '服务包管理',
          permission: ['teacher']
        }
      },
      {
        path: 'order',
        name: 'TeacherOrder',
        component: () => import('../views/teacher/Order.vue'),
        props: (route) => ({
          page: route.query.page,
          status: route.query.status
        }),
        meta: {
          title: '订单管理',
          permission: ['teacher']
        }
      },
      {
        path: 'order-details/:ordernum',
        name: 'TeacherOrderDetails',
        component: () => import('../views/teacher/OrderDetails.vue'),
        props: (route) => ({ ordernum: route.params.ordernum }), // 解耦合
        meta: {
          title: '订单详情',
          permission: ['teacher']
        }
      },
      {
        path: 'order-cancel/:ordernum',
        name: 'TeacherOrderCancel',
        component: () => import('../views/teacher/OrderCancel.vue'),
        props: (route) => ({ ordernum: route.params.ordernum }),
        meta: {
          title: '订单取消审核',
          permission: ['teacher']
        }
      },
      {
        path: 'message',
        name: 'TeacherMessage',
        component: () => import('../views/teacher/Message.vue'),
        meta: {
          title: '客户消息',
          permission: ['teacher']
        }
      },
      {
        path: 'message-ing',
        name: 'TeacherMessageIng',
        component: () => import('../views/teacher/MessageIng.vue'),
        meta: {
          title: '客户消息',
          permission: ['teacher']
        }
      },
      {
        path: 'promote',
        name: 'TeacherPromote',
        component: () => import('../views/teacher/Promote.vue'),
        meta: {
          title: '我要推广',
          permission: ['teacher']
        }
      },
      {
        path: 'promote-withdrawal',
        name: 'TeacherPromoteWithDrawal',
        component: () => import('../views/teacher/PromoteWithdrawal.vue'),
        meta: {
          title: '推广提现',
          permission: ['teacher']
        }
      },
      {
        path: 'worksheet',
        name: 'TeacherWorksheet',
        component: () => import('../views/teacher/Worksheet.vue'),
        props: (route) => ({
          page: route.query.page,
          status: route.query.status
        }),
        meta: {
          title: '我的工单',
          permission: ['teacher']
        }
      },
      {
        path: 'worksheet-details/:id',
        name: 'TeacherWorksheetDetails',
        component: () => import('../views/teacher/WorksheetDetails.vue'),
        props: true,
        meta: {
          title: '我的工单',
          permission: ['teacher']
        }
      },
      {
        path: 'worksheet-post',
        name: 'TeacherWorksheetPost',
        component: () => import('../views/teacher/WorksheetPost.vue'),
        meta: {
          title: '提交工单',
          permission: ['teacher']
        }
      },
      {
        path: 'my-article',
        name: 'TeacherMyArticle',
        component: () => import('../views/teacher/MyArticle.vue'),
        props: (route) => ({
          page: route.query.page,
          status: route.query.status
        }),
        meta: {
          title: '我的文章',
          permission: ['teacher']
        }
      },
      {
        path: 'article-post',
        name: 'TeacherArticlePost',
        component: () => import('../views/teacher/ArticlePost.vue'),
        props: (route) => ({ id: route.query.id }),
        meta: {
          title: '发表文章',
          permission: ['teacher']
        }
      },
      {
        path: 'comment',
        name: 'TeacherComment',
        component: () => import('../views/teacher/Comment.vue'),
        meta: {
          title: '评论管理',
          permission: ['teacher']
        }
      }
    ]
  },
  {
    path: '/user',
    component: RouteView,
    redirect: '/user/info',
    meta: { permission: ['user'] },
    children: [
      {
        path: 'info',
        name: 'UserInfo',
        component: () => import('../views/user/Info.vue'),
        meta: {
          title: '用户基本信息',
          permission: ['user']
        }
      },
      {
        path: 'security',
        name: 'UserSecurity',
        component: () => import('../views/user/Security.vue'),
        meta: {
          title: '教员安全中心',
          permission: ['user']
        }
      },
      {
        path: 'realname',
        name: 'UserRealname',
        component: () => import('../views/user/Realname.vue'),
        meta: {
          title: '实名认证',
          permission: ['user']
        }
      },
      {
        path: 'students',
        name: 'UserStudents',
        component: () => import('../views/user/Students.vue'),
        meta: {
          title: '学员管理',
          permission: ['user']
        }
      },
      {
        path: 'student-edit/:id',
        name: 'UserStudentEdit',
        component: () => import('../views/user/StudentEdit.vue'),
        props: true,
        meta: {
          title: '学员编辑',
          permission: ['user']
        }
      },
      {
        path: 'order',
        name: 'UserOrder',
        component: () => import('../views/user/Order.vue'),
        props: (route) => ({
          page: parseInt(route.query.page),
          status: route.query.status
        }),
        meta: {
          title: '订单管理',
          permission: ['user']
        }
      },
      {
        path: 'order-details/:ordernum',
        name: 'UserOrderDetails',
        component: () => import('../views/user/OrderDetails.vue'),
        props: (route) => ({ ordernum: route.params.ordernum }), // 解耦合
        meta: {
          title: '订单详情',
          permission: ['user']
        }
      },
      {
        path: 'order-cancel/:ordernum',
        name: 'UserOrderCancel',
        component: () => import('../views/user/OrderCancel.vue'),
        props: (route) => ({ ordernum: route.params.ordernum }),
        meta: {
          title: '订单取消审核',
          permission: ['user']
        }
      },
      {
        path: 'message',
        name: 'UserMessage',
        component: () => import('../views/user/Message.vue'),
        meta: {
          title: '教员消息',
          permission: ['user']
        }
      },
      {
        path: 'message-ing',
        name: 'UserMessageIng',
        component: () => import('../views/user/MessageIng.vue'),
        meta: {
          title: '客户消息',
          permission: ['user']
        }
      },
      {
        path: 'promote',
        name: 'UserPromote',
        component: () => import('../views/user/Promote.vue'),
        meta: {
          title: '我要推广',
          permission: ['user']
        }
      },
      {
        path: 'promote-withdrawal',
        name: 'UserPromoteWithDrawal',
        component: () => import('../views/user/PromoteWithdrawal.vue'),
        meta: {
          title: '推广提现',
          permission: ['user']
        }
      },
      {
        path: 'worksheet',
        name: 'UserWorksheet',
        component: () => import('../views/user/Worksheet.vue'),
        props: (route) => ({
          page: route.query.page,
          status: route.query.status
        }),
        meta: {
          title: '我的工单',
          permission: ['user']
        }
      },
      {
        path: 'worksheet-details/:id',
        name: 'UserWorksheetDetails',
        component: () => import('../views/user/WorksheetDetails.vue'),
        props: true,
        meta: {
          title: '我的工单',
          permission: ['user']
        }
      },
      {
        path: 'worksheet-post',
        name: 'UserWorksheetPost',
        component: () => import('../views/user/WorksheetPost.vue'),
        meta: {
          title: '提交工单',
          permission: ['user']
        }
      },
      {
        path: 'my-article',
        name: 'UserMyArticle',
        component: () => import('../views/user/MyArticle.vue'),
        props: (route) => ({
          page: route.query.page,
          status: route.query.status
        }),
        meta: {
          title: '我的文章',
          permission: ['user']
        }
      },
      {
        path: 'article-post',
        name: 'UserArticlePost',
        component: () => import('../views/user/ArticlePost.vue'),
        props: (route) => ({ id: route.query.id }),
        meta: {
          title: '发表文章',
          permission: ['user']
        }
      },
      {
        path: 'comment',
        name: 'UserComment',
        component: () => import('../views/user/Comment.vue'),
        props: (route) => ({ page: route.query.page }),
        meta: {
          title: '评论管理',
          permission: ['user']
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    // 首页
    path: '/',
    name: 'Index',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Index.vue'),
    meta: {
      keepAlive: true,
      title: '首页',
      keywords: '家教,小橙家教网,小橙教育,小橙家教平台',
      description: '小橙家教网致力于构建安全的、优质的、可信任的家教体系'
    }
  },
  {
    // 推广页面
    path: '/promote',
    name: 'Promote',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Promote.vue'),
    meta: {
      keepAlive: true,
      title: '我要推广',
      keywords: '小橙家教推广，推广',
      description: '推广展示页面'
    }
  },
  {
    // 修改城市
    path: '/change-city',
    name: 'ChangeCity',
    component: () => import('../views/ChangeCity.vue'),
    meta: {
      title: '修改城市',
      keywords: '城市,位置,修改城市'
    }
  },
  {
    path: '/tutor',
    component: RouteView,
    redirect: '/tutor/list',
    children: [
      {
        path: 'list',
        name: 'TutorList',
        component: () => import('../views/tutor/List.vue'),
        props: (route) => ({
          page: route.query.page,
          week_day: route.query.week_day,
          area: route.query.area,
          sex: route.query.sex,
          category: route.query.category,
          course: route.query.course
        }),
        meta: {
          title: '找家教',
          keywords: '找家教,家教服务',
          description: '筛选符合条件的家教服务'
        }
      },
      {
        path: 'info/:id',
        name: 'TutorInfo',
        component: () => import('../views/tutor/Info.vue'),
        props: true,
        meta: {
          title: '服务包详情',
          keywords: '服务包,家教服务,价格'
        }
      },
      {
        path: 'pay/:id',
        name: 'TutorPay',
        component: () => import('../views/tutor/Pay.vue'),
        props: true,
        meta: {
          title: '支付',
          keywords: '支付页面'
        }
      }
    ]
  },
  {
    path: '/reveal',
    component: RouteView,
    redirect: '/reveal/list',
    children: [
      {
        path: 'list',
        name: 'RevealList',
        component: () => import('../views/reveal/List.vue'),
        props: (route) => ({
          page: route.query.page,
          area: route.query.area,
          type: route.query.type,
          sex: route.query.sex,
          school: route.query.school,
          teacher_id: route.query.teacher_id
        }),
        meta: {
          title: '教员风采'
        }
      },
      {
        path: 'info/:id',
        name: 'RevealInfo',
        component: () => import('../views/reveal/Info.vue'),
        props: true,
        meta: {
          title: '教员展示'
        }
      }
    ]
  },
  {
    // 论坛
    path: '/forum',
    component: RouteView,
    redirect: '/forum/list',
    children: [
      {
        path: 'list',
        name: 'ForumList',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/forum/List.vue'),
        meta: {
          title: '论坛列表'
        }
      },
      {
        path: 'info/:id',
        name: 'ForumInfo',
        component: () => import('../views/forum/Info.vue'),
        props: true,
        meta: {
          title: '帖子详情'
        }
      }
    ]
  },
  {
    // 帮助中心
    path: '/helps',
    component: RouteView,
    redirect: '/helps/category',
    children: [
      {
        path: 'category/:id',
        name: 'HeplsCategory',
        component: () => import('@/views/helps/Category.vue'),
        props: true,
        meta: {
          title: '帮助中心'
        }
      },
      {
        path: 'info/:id',
        name: 'HelpsInfo',
        component: () => import('@/views/helps/Info.vue'),
        props: true,
        meta: {
          title: '帮助中心'
        }
      },
      {
        path: 'search',
        name: 'HelpSearch',
        component: () => import('@/views/helps/Search.vue'),
        props: (route) => ({ keywords: route.query.keywords }),
        meta: {
          title: '搜索帮助'
        }
      }
    ]
  },
  {
    // 新闻
    path: '/news',
    component: RouteView,
    redirect: '/news/list',
    children: [
      {
        path: 'list',
        name: 'NewsList',
        component: () => import('@/views/news/List.vue'),
        props: (route) => ({ page: route.query.page }),
        meta: {
          title: '新闻中心'
        }
      },
      {
        path: 'info/:id',
        name: 'NewsInfo',
        component: () => import('@/views/news/Info.vue'),
        props: true,
        meta: {
          title: '新闻详情'
        }
      }
    ]
  },
  {
    // 公告
    path: '/announce',
    component: RouteView,
    redirect: '/announce/list',
    children: [
      {
        path: 'list',
        name: 'AnnounceList',
        component: () => import('@/views/announce/List.vue'),
        props: (route) => ({ page: route.query.page }),
        meta: {
          title: '新闻中心'
        }
      },
      {
        path: 'info/:id',
        name: 'AnnounceInfo',
        component: () => import('@/views/announce/Info.vue'),
        props: true,
        meta: {
          title: '公告详情'
        }
      }
    ]
  },
  {
    // 文章legal-agreement
    path: '/article',
    component: RouteView,
    redirect: '/article/list',
    children: [
      {
        path: 'list',
        name: 'ArticleList',
        component: () => import('@/views/article/List.vue'),
        props: (route) => ({ page: route.query.page }),
        meta: {
          title: '其他文章'
        }
      },
      {
        path: 'info/:id',
        name: 'ArticleInfo',
        component: () => import('@/views/article/Info.vue'),
        props: true,
        meta: {
          title: '文章详情'
        }
      }
    ]
  },
  {
    path: '/account',
    name: 'account',
    component: RouteView,
    meta: { title: '首页' },
    redirect: '/account/user-login',
    children: [
      {
        path: 'user-login',
        name: 'UserLogin',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/user_account/UserLogin.vue'
          ),
        meta: { title: '用户登录', keepAlive: false }
      },
      {
        path: 'user-register',
        name: 'UserRegister',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/user_account/UserRegister.vue'
          ),
        props: (route) => ({ promo_code: route.query.promo_code }),
        meta: { title: '用户注册', keepAlive: false }
      },
      {
        path: 'user-retrieve-pass',
        name: 'UserRetrievePass',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/user_account/UserRetrievePass.vue'
          ),
        meta: { title: '用户忘记密码', keepAlive: false }
      },
      {
        path: 'user-retrieve-pass-email',
        name: 'UserRetrievePassEmail',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/user_account/UserRetrievePassEmail.vue'
          ),
        meta: { title: '用户忘记密码', keepAlive: false }
      },
      {
        path: 'user-reset-pass',
        name: 'UserResetPass',
        component: () => import('../views/user_account/UserResetPass.vue'),
        // props: (route) => ({ change_pass_token: route.query.change_pass_token }),
        props: (route) => ({
          change_pass_token: route.query.change_pass_token
        }),
        meta: { title: '用户重置密码', keepAlive: false }
      },
      // 教员账户
      {
        path: 'teacher-login',
        name: 'TeacherLogin',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/teacher_account/TeacherLogin.vue'
          ),
        meta: { title: '用户登录', keepAlive: false }
      },
      {
        path: 'teacher-register',
        name: 'TeacherRegister',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/teacher_account/TeacherRegister.vue'
          ),
        props: (route) => ({ promo_code: route.query.promo_code }),
        meta: { title: '用户注册', keepAlive: false }
      },
      {
        path: 'teacher-retrieve-pass',
        name: 'TeacherRetrievePass',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/teacher_account/TeacherRetrievePass.vue'
          ),
        meta: { title: '用户忘记密码', keepAlive: false }
      },
      {
        path: 'teacher-retrieve-pass-email',
        name: 'TeacherRetrievePassEmail',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/teacher_account/TeacherRetrievePassEmail.vue'
          ),
        meta: { title: '用户忘记密码', keepAlive: false }
      },
      {
        path: 'teacher-reset-pass',
        name: 'TeacherResetPass',
        component: () =>
          import('../views/teacher_account/TeacherResetPass.vue'),
        props: (route) => ({
          change_pass_token: route.query.change_pass_token
        }),
        meta: { title: '用户重置密码', keepAlive: false }
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () =>
      import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }
]

/**
 * 默认路由
 */
export const defaultRoutePath = '/index'

/**
 * 白名单：不需要授权可访问的列表
 * @type { *[] }
 */
export const whiteList = [
  'UserLogin',
  'UserRegister',
  'UserRetrievePass',
  'UserRetrievePassEmail',
  'UserResetPass',
  'TeacherLogin',
  'TeacherRegister',
  'TeacherRetrievePass',
  'TeacherRetrievePassEmail',
  'TeacherResetPass',
  '404',
  'Index',
  'TutorList',
  'TutorInfo',
  'ForumList',
  'ForumInfo',
  'Aaa',
  'RevealList',
  'RevealInfo',
  'HeplsCategory',
  'HelpsInfo',
  'HelpSearch',
  'NewsList',
  'NewsInfo',
  'AnnounceList',
  'AnnounceInfo',
  'ChangeCity',
  'Promote',
  'ArticleList',
  'ArticleInfo'
]

/**
 * 登录后不能访问的页面
 * @type { *[] }
 */
export const loginCannotAccess = [
  'UserLogin',
  'UserRegister',
  'UserRetrievePass',
  'UserRetrievePassEmail',
  'UserResetPass',
  'TeacherLogin',
  'TeacherRegister',
  'TeacherRetrievePass',
  'TeacherRetrievePassEmail',
  'TeacherResetPass'
]
